import { useUiStore } from '@/stores';
import { format, parseISO } from 'date-fns';

export default () => {
  const uiStore = useUiStore();

  const formatDateTime = (date: string | undefined) => {
    if (date) {
      const dt: Date = parseISO(date);
      if (dt instanceof Date) return format(dt, uiStore.getDateTimeFormat);
    }
    return date || '';
  };
  return {
    formatDateTime,
  };
};
